module.exports = __webpack_public_path__ + "static/TMD intraoral before-9d9b1ec3a29ae04e08e4754cfa281974.jpg";